<template>
  <div class="lg:flex hidden gap-[30px] flex-col items-center">
    <p class="text-[32px] font-bold text-black">Jste přihlášeni na <span class="text-[#2699C6]">{{workshopsMutable.length}}</span> workshop<span v-if="workshopsMutable.length === 0">ů</span><span v-if="workshopsMutable.length >1 && workshopsMutable.length < 5">y</span>.</p>
    <a :href="route('frontend.homepage') + '#workshopy'" class="w-[550px] justify-center flex rounded-[20px] bg-brand-blue">
      <svg class="my-2" xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
        <path d="M4.04826 13.7773C4.04826 14.4563 4.59863 15.0066 5.27756 15.0066L11.5103 15.0066L11.5103 21.2394C11.5103 21.9183 12.0607 22.4687 12.7396 22.4687C13.4185 22.4687 13.9689 21.9183 13.9689 21.2394L13.9689 15.0066L20.2017 15.0066C20.8806 15.0066 21.431 14.4562 21.431 13.7773C21.431 13.0985 20.8806 12.5481 20.2017 12.5481L13.9689 12.5481L13.9689 6.31529C13.9689 5.63639 13.4185 5.08601 12.7396 5.086C12.0606 5.08606 11.5103 5.63638 11.5103 6.31528L11.5103 12.5481L5.27755 12.548C4.59864 12.548 4.04826 13.0984 4.04826 13.7773Z" fill="#F5F5F5"/>
      </svg>
    </a>
    <div v-for="workshop in workshopsMutable" class="relative flex flex-col bg-white shadow rounded-[20px] w-[550px]">
      <div class="absolute right-5 top-[34px] flex items-end justify-end pr-3 flex-nowrap">
        <button class="flex flex-row gap-2 justify-self-end py-2 px-5 rounded-full bg-brand-blue text-white flex-nowrap whitespace-nowrap" @click="unRegisterWorkshop(workshop.id)">Odhlásit se
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
            <path d="M5.83073 2.50195H4.16406C4.16406 1.08528 5.2474 0.00195312 6.66406 0.00195312V1.66862C6.16406 1.66862 5.83073 2.00195 5.83073 2.50195Z" fill="white"/>
            <path d="M12.5 2.50195H10.8333C10.8333 2.00195 10.5 1.66862 10 1.66862V0.00195312C11.4167 0.00195312 12.5 1.08528 12.5 2.50195Z" fill="white"/>
            <path d="M12.4974 5.00195H4.16406V2.50195H5.83073V3.33529H10.8307V2.50195H12.4974V5.00195Z" fill="white"/>
            <path d="M9.9974 0.00195312H6.66406V1.66862H9.9974V0.00195312Z" fill="white"/>
            <path d="M15.8333 5.00455H0.833333C0.333333 5.00455 0 4.67122 0 4.17122C0 3.67122 0.333333 3.33789 0.833333 3.33789H15.8333C16.3333 3.33789 16.6667 3.67122 16.6667 4.17122C16.6667 4.67122 16.3333 5.00455 15.8333 5.00455Z" fill="white"/>
            <path d="M14.1641 19.9993H2.4974C1.9974 19.9993 1.66406 19.666 1.66406 19.166V7.49935C1.66406 6.99935 1.9974 6.66602 2.4974 6.66602H14.1641C14.6641 6.66602 14.9974 6.99935 14.9974 7.49935V19.166C14.9974 19.666 14.6641 19.9993 14.1641 19.9993ZM3.33073 18.3327H13.3307V8.33268H3.33073V18.3327Z" fill="white"/>
            <path d="M6.66927 16.6686C6.16927 16.6686 5.83594 16.3353 5.83594 15.8353V10.8353C5.83594 10.3353 6.16927 10.002 6.66927 10.002C7.16927 10.002 7.5026 10.3353 7.5026 10.8353V15.8353C7.5026 16.3353 7.16927 16.6686 6.66927 16.6686Z" fill="white"/>
            <path d="M9.9974 16.6686C9.4974 16.6686 9.16406 16.3353 9.16406 15.8353V10.8353C9.16406 10.3353 9.4974 10.002 9.9974 10.002C10.4974 10.002 10.8307 10.3353 10.8307 10.8353V15.8353C10.8307 16.3353 10.4974 16.6686 9.9974 16.6686Z" fill="white"/>
          </svg>
        </button>
      </div>
      <div>
        <p class="border-b-2 border-brand-blue w-[75%] ml-[20px] text-[24px] pt-3 pb-2 font-bold text-[#2699C6] text-left" style="line-height: 32px">{{ workshop.start }}–{{ workshop.end }}</p>
      </div>
      <div class="flex flex-row mt-4 ml-5 mb-5 gap-4">
        <div class="shrink-0">
          <img class="w-[120px] h-[120px] shrink-0 rounded-full" src="/assets/sara.png" :alt="workshop.speaker.name">
        </div>
        <div class="flex flex-col gap-2">
          <div class="mt-4">
            <p class="text-[#2699C6] font-semibold text-[18px] uppercase" style="line-height: 24px">{{workshop.speaker.name}}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-900 text-[24px]" style="line-height: normal;">{{ workshop.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="lg:hidden block w-full">
    <p class="text-[22px] font-bold text-center mb-4 text-black">Jste přihlášeni na <span class="text-[#2699C6]">{{workshopsMutable.length}}</span> workshop<span v-if="workshopsMutable.length === 0">ů</span><span v-if="workshopsMutable.length >1 && workshopsMutable.length < 5">y</span>.</p>
    <div v-for="workshop in workshopsMutable" class="flex flex-col mb-4 bg-white rounded-[20px] w-full">
      <div class="flex flex-row justify-between bg-brand-blue rounded-t-[20px]">
        <div class="ml-2">
          <p class="text-[18px] py-2 pl-2 font-bold text-white " style="line-height: 32px">{{ workshop.start }}–{{ workshop.end }}</p>
        </div>
        <div style="align-self: center; margin-right:12px">
          <button class="flex flex-row gap-2 justify-self-end py-2 px-3 rounded-full bg-white text-[#2699C6] flex-nowrap whitespace-nowrap" @click="unRegisterWorkshop(workshop.id)">Odhlásit se
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="#2699C6">
              <path d="M5.83073 2.50195H4.16406C4.16406 1.08528 5.2474 0.00195312 6.66406 0.00195312V1.66862C6.16406 1.66862 5.83073 2.00195 5.83073 2.50195Z" fill="#2699C6"/>
              <path d="M12.5 2.50195H10.8333C10.8333 2.00195 10.5 1.66862 10 1.66862V0.00195312C11.4167 0.00195312 12.5 1.08528 12.5 2.50195Z" fill="#2699C6"/>
              <path d="M12.4974 5.00195H4.16406V2.50195H5.83073V3.33529H10.8307V2.50195H12.4974V5.00195Z" fill="#2699C6"/>
              <path d="M9.9974 0.00195312H6.66406V1.66862H9.9974V0.00195312Z" fill="#2699C6"/>
              <path d="M15.8333 5.00455H0.833333C0.333333 5.00455 0 4.67122 0 4.17122C0 3.67122 0.333333 3.33789 0.833333 3.33789H15.8333C16.3333 3.33789 16.6667 3.67122 16.6667 4.17122C16.6667 4.67122 16.3333 5.00455 15.8333 5.00455Z" fill="#2699C6"/>
              <path d="M14.1641 19.9993H2.4974C1.9974 19.9993 1.66406 19.666 1.66406 19.166V7.49935C1.66406 6.99935 1.9974 6.66602 2.4974 6.66602H14.1641C14.6641 6.66602 14.9974 6.99935 14.9974 7.49935V19.166C14.9974 19.666 14.6641 19.9993 14.1641 19.9993ZM3.33073 18.3327H13.3307V8.33268H3.33073V18.3327Z" fill="#2699C6"/>
              <path d="M6.66927 16.6686C6.16927 16.6686 5.83594 16.3353 5.83594 15.8353V10.8353C5.83594 10.3353 6.16927 10.002 6.66927 10.002C7.16927 10.002 7.5026 10.3353 7.5026 10.8353V15.8353C7.5026 16.3353 7.16927 16.6686 6.66927 16.6686Z" fill="#2699C6"/>
              <path d="M9.9974 16.6686C9.4974 16.6686 9.16406 16.3353 9.16406 15.8353V10.8353C9.16406 10.3353 9.4974 10.002 9.9974 10.002C10.4974 10.002 10.8307 10.3353 10.8307 10.8353V15.8353C10.8307 16.3353 10.4974 16.6686 9.9974 16.6686Z" fill="#2699C6"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="flex flex-row mt-4 ml-5 mb-5 gap-4">
        <div class="shrink-0">
          <img class="w-[100px] h-[100px] shrink-0 rounded-full" src="/assets/sara.png" :alt="workshop.speaker.name">
        </div>
        <div class="flex flex-col gap-2">
          <div class="mt-4">
            <p class="text-[#2699C6] font-semibold text-[16px] uppercase" style="line-height: 24px">{{workshop.speaker.name}}</p>
          </div>
          <div>
            <p class="font-semibold text-gray-900 text-[18px]" style="line-height: normal;">{{ workshop.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgramCard from "../Program/ProgramCard.vue";
import ProgramCardModal from "../Program/ProgramCardModal.vue";
import axios from "axios";

export default {
  components: {
    ProgramCard,
    ProgramCardModal,
  },

  data() {
    return {
      workshopRegistrationState: {
        user_registrations: [],
      },
      workshopsMutable: {},
      selectedProgramArticle: null,
    };
  },
  props: {
    workshops: {
      type: Array,
      default: () => [],
    },
    maxWorkshopRegistrationsPerUser: {
      type: Number,
    },
  },

  methods: {
    async unRegisterWorkshop(workshopId) {
      try {
        const res = await axios.delete(
          `/api/workshop/${workshopId}/registration`,
          {}
        );

        this.workshopRegistrationState = res.data;

        this.workshopsMutable = this.workshopsMutable.filter(
          (w) => w.id !== workshopId
        );
      } catch (err) {}
    },
  },

  created() {
    this.workshopsMutable = this.workshops;

    for (let workshop of this.workshopsMutable) {
      this.workshopRegistrationState.user_registrations.push(workshop.id);
    }
  },
};
</script>

<style>
</style>
